'use strict';

angular.module('core').factory(
  'SupportedLanguages',
  [
    '$resource',
    function ($resource) {
      var resourceUrl = 'v1/supported-languages';
      return $resource(
        resourceUrl,
        {
          get: {
            method: 'get'
          }
        }
      );
    }
  ]
);
